import { ROLES } from './ROLES';

export const premiumCards = [
    {
        id: 'CONTRACTOR',
        name: 'Contratante',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'MARKETING_CONTACT',
        name: 'Contacto Marketing',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'AGENTS',
        name: 'Agentes',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.LOGISTIC,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ]
    },
    {
        id: 'DELIVERY_ADDRESS',
        name: 'Dirección de entrega',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.LOGISTIC,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'PRODUCTS',
        name: 'Productos',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.LOGISTIC,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ]
    },
    {
        id: 'VENDORS',
        name: 'Proveedores',
        default: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO]
    },
    {
        id: 'SHIPPING',
        name: 'Envío',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.LOGISTIC,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'FILES',
        name: 'Archivos',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.LOGISTIC,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ]
    },
    {
        id: 'COMMENTS',
        name: 'Comentarios',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.LOGISTIC,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'LOGISTIC',
        name: 'Logística',
        default: [
            ROLES.ADMINISTRATOR,
            ROLES.COMPRAS,
            ROLES.COMPRAS_SR,
            ROLES.OPERATIVO,
            ROLES.LOGISTIC,
            ROLES.PROVEEDOR_SD
        ]
    },
    {
        id: 'ALENDUM',
        name: 'Alendum',
        default: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO, ROLES.PROVEEDOR_SD]
    }
];
